import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import HelpBlock from "./HelpBlock";
import classNames from 'classnames'

const Question = styled('div')`
  padding-bottom: 0.5em;
  
  & .ctrl-label {
    color: #030303;
  }
  
  & .question {
    padding-bottom: 1em;
  }
  & label {
    display: inline-block;      
    margin-right: 1em;
    font-weight: normal;
    
    & input {
      margin: 0 4px;
    }    
  }     
  `;

const RadioButtonQuestion = (props) => {
  const {id, items, value, question, onChange, disabled, children, error, displayQuestion = true} = props;

  const classes = classNames(
    'form-group',
    {'has-error': error}
  );
  return (
    <Question className={classes}>
      {displayQuestion && <div className="question">{question}</div>}
      {items.map((item, index)=> {
        return (
          <label htmlFor={`${id}${index}`} key={item.value}>
            <input
              id={`${id}${index}`}
              type="radio"
              value={item.value}
              disabled={disabled}
              onChange={e => onChange(e.currentTarget.value)}
              checked={value === item.value}
            />
            {item.text}
          </label>
        );
      })}
      {children}
      {error && (<HelpBlock type="error"/>)}
    </Question>
  );
};

RadioButtonQuestion.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  question: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  displayQuestion: PropTypes.bool
};

RadioButtonQuestion.YesNo = [{text: 'Yes', value: 'yes'}, {text: 'No', value: 'no'}];
RadioButtonQuestion.YesNoNotApplicable = [...RadioButtonQuestion.YesNo, {text: 'N/A', value: 'N/A'}];
RadioButtonQuestion.createItem = (text, value) => ({text, value});

export default RadioButtonQuestion;



// WEBPACK FOOTER //
// ./src/components/forms/RadioButtonQuestion.js